export class StampaModelloPreventivoIN {
    idProgetto: number

}
